import httpClient from '@/http-client'

export const serviceRequest = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/service-orders/service-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const serviceRequestExportExcel = attributes => {
  return httpClient
    .post(
      "/api/v1/reports/service-orders/service-requests/export-excels", attributes,
      { responseType: "arraybuffer" }
    )
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data));
};

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/service-orders/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  serviceRequest,
  serviceRequestExportExcel,
  formViewModel
}
